import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreMaintainenceResponse } from '../components/model/store-maintainence-response';
import { AppConstants } from '../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  constructor(private httpClient: HttpClient) { }



  getStoreBySequence(sequence): Observable<StoreMaintainenceResponse> {

    return this.httpClient.get<StoreMaintainenceResponse>(AppConstants.GET_STORE_BY_SEQ + "/" + encodeURIComponent(sequence));

  }

  getAllStores(upn): Observable<StoreMaintainenceResponse[]> {

    return this.httpClient.get<StoreMaintainenceResponse[]>(AppConstants.GET_STORES + "?upn=" + upn);

  }

  getStoreByStoreNum(storeNum): Observable<StoreMaintainenceResponse[]> {

    return this.httpClient.get<StoreMaintainenceResponse[]>(AppConstants.GET_STORES + "?upn=" + storeNum);

  }

  updateEmailAddres(storeNum,emailIds:string[]): Observable<number> {

    return this.httpClient.put<number>(AppConstants.UPDATE_STORE_EMAIL+"/"+storeNum,emailIds);

  }
  updateStore(storeData): Observable<number> {

    return this.httpClient.put<number>(AppConstants.UPDATE_STORE,storeData);

  }

  
}
